import React from 'react';
import logo from '../assets/img/logo.png';
const Header = () => {

    return (
        <React.Fragment>
            <header>
                <div className='bg-customRed h-20 flex items-center justify-center top-0 w-full z-50'>
                    <img src={logo} alt="logo" className='p-1 pl-1 pb-3 pt-3 h-full'/>
                    <h1 className='text-white font-bebas md:text-4xl text-2xl ml-5 tracking-wide'>Participació de clubs en millores</h1>      
                </div>
            </header>
        </React.Fragment>
    );
}

export default Header;